import { render } from "./strategyCard1.vue?vue&type=template&id=687b106a&scoped=true"
import script from "./strategyCard1.vue?vue&type=script&lang=js"
export * from "./strategyCard1.vue?vue&type=script&lang=js"

import "./strategyCard1.vue?vue&type=style&index=0&id=687b106a&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687b106a"]])

export default __exports__